import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { editProfileDetails, fetchUserDetailsById, fetchUserRolesData, postNewUserData } from "../services/user.api";
import { toast } from "react-toastify";
import KEYS from "../consts/consts";
import { removeStorageValue } from "../utils/cookies";

export interface User {
  userId?: number | string;
  name: string;
  role?: string | number;
  userRoleId?: number | string;
  email: string;
}
export interface UserForm {
  userId?: number | string;
  name: string;
  userRoleId?: number | string;
  email?: string;
  password?: string;
}
export interface UserRoleDropdownItem {
  id: number;
  name: string; 
}
interface UserState {
  newUser: boolean;
  userProfile: User | null;
  loading: boolean;
  error: string | null;
  userLoading: boolean;
  userUpdateSuccess: boolean,
  userRoles:UserRoleDropdownItem[]
};
const initialState: UserState = {

  newUser: false,
  userProfile: null,
  loading: false,
  error: null,
  userLoading: false,
  userUpdateSuccess: false,
  userRoles:[]
};

export const postNewUser = createAsyncThunk(
  "newuserdata/post",
  async (value: any) => {
    const response = await postNewUserData(value);
    return response.data;
  }
);

export const fetchUserRoles = createAsyncThunk(
  "userroles/fetch",
  async () => {
    const response = await fetchUserRolesData();
    return response.data;
  }
);
export const fetchUserById = createAsyncThunk('get/userById', 
  async () => {
    const response = await fetchUserDetailsById();
    return response.data;
  }
);
export const editProfileData = createAsyncThunk('edit/profile', async (data: UserForm) => {
  const response =await editProfileDetails(data);
  toast.success(KEYS.PROFILE_UPDATED);
  return response?.data;
});

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    resetUserUpdateSuccess: state => {
      state.userUpdateSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(postNewUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postNewUser.fulfilled, (state, action) => {
        state.loading = false;
        state.newUser = action.payload
      })
      .addCase(postNewUser.rejected, (state) => {
        state.loading = false;
        state.error = "Failed to create new user";
      })
      .addCase(fetchUserRoles.fulfilled, (state, action) => {
        state.loading = false;
        state.userRoles = action.payload
      })

      .addCase(fetchUserById.pending, state => {
        state.userLoading = true;
        state.userProfile = initialState.userProfile;
      })
      .addCase(fetchUserById.fulfilled, (state, action) => {
        state.userProfile = action.payload;
        state.userLoading = false;
      })
      .addCase(fetchUserById.rejected, (state, action) => {
        state.userLoading = false;
        state.userProfile = initialState.userProfile;
        if (action?.error?.message && action.error.message.indexOf('401') !== -1) {
          removeStorageValue('access_token');
          location.replace('/login');
        }
      })
      .addCase(editProfileData.pending, state => {
        state.loading = true;
      })
      .addCase(editProfileData.fulfilled, state => {
        state.loading = false;
        state.userUpdateSuccess = true;
      })
      .addCase(editProfileData.rejected, (state, action) => {
        state.loading = false;
        if (action?.error?.message && action.error.message.indexOf('401') !== -1) {
          removeStorageValue('access_token');
          location.replace('/login');
        }
      })
  },
});

export const {resetUserUpdateSuccess } = userSlice.actions;
export default userSlice.reducer;